import React from 'react'
import { HandleInvoiceStateProvider } from './Components/HandleInvoiceStateProvider'

import NewCreditNotePrime from './NewCreditNotePrime'
import { AccountDetailsProvider } from './Components/AccountDetailsProvider'

function CreateCreditNote({ isVoucher,accountDetails }) {


  return (
    <AccountDetailsProvider accountDetails={accountDetails}>
    <HandleInvoiceStateProvider>
      <NewCreditNotePrime isVoucher={isVoucher}  />
    </HandleInvoiceStateProvider>
    </AccountDetailsProvider>
  )
}

export default CreateCreditNote